import { useState } from "react";

export const useError = () => {
	const [error, setError] = useState({ show: false, title: '', content: '' });
	const showError = (title, message) => setError({ show: true, title, content: message });
	const toggleError = () => setError(e => ({ ...e, show: !e.show }));

	return [error, showError, toggleError];
};